module.exports = __webpack_public_path__ + "img/wayfinder-main-features-fr.8c870542.png";